/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StudySiteCallbackDto = {
    id?: string;
    studySiteId?: number;
    name: string;
    status: StudySiteCallbackDto.status;
    siteCode: string;
    study?: string;
    studyTrackingId?: number;
    protocol?: string;
    country?: string;
    language?: string;
    callType: StudySiteCallbackDto.callType;
    start?: string;
    end?: string;
    callBackStatus?: string;
    isEscalated?: boolean;
    spms?: string;
    isOptedOut?: boolean;
    isByeBye?: boolean;
}

export namespace StudySiteCallbackDto {

    export enum status {
        SETUP = 'SETUP',
        CANCELED = 'CANCELED',
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        PAUSED = 'PAUSED',
        CLOSEOUT = 'CLOSEOUT',
        COMPLETED = 'COMPLETED',
        REMOVED = 'REMOVED',
    }

    export enum callType {
        OPT_IN = 'OPT_IN',
        TRAINING = 'TRAINING',
        FOLLOW_UP = 'FOLLOW_UP',
    }


}
